import * as DispatchMethods from "./modules/dispatcher/methods";

export namespace Modal.Dispatch {
  export const OpenModal = DispatchMethods.openModal;
  export const CloseModal = DispatchMethods.closeModal;
}



// WEBPACK FOOTER //
// ./src/components/modal/index.ts